<span class="flex flex-column">
  @if (this.newText) {
    <span class='font-medium' [ngClass]="{'largeFont': newLargeText, 'new': true}">
      {{newText}}
    </span>
  }
  <span>
    @if (newDate && !omitDiscontinuedLabel) {
      <span class="discontinued">
        @if (discontinuedModel?.discontinuedprefixText) {
          {{ discontinuedModel?.discontinuedprefixText }}
        }
        {{ 'COMMON.DISCONTINUED' | translate: {date: (newDate | dateToLocal)} }}
      </span>
    }
  </span>
  <app-first-time-delivery [model]="AllAssortments"></app-first-time-delivery>
</span>